import { useCallback } from "react";
import { REPORT_PAGES_ROUTES, headerHeight, reproID } from "../../constants";
import { filterByLink } from "../../store/issuesSlice";
import { scrollTo } from "../../store/sdlcReportSlice";
import { convertFinalCheckLabel } from "../../utils";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { useReportDispatch } from "./index";
const useRiskAssessmentClick = ({ reportId, diffId, riskCategory, violations, selectedCheck, }) => {
    var _a;
    const dispatch = useReportDispatch();
    const { data: summary } = useGetReportSummaryQuery({
        diff_report_id: diffId !== null && diffId !== void 0 ? diffId : "",
        ui_id: reportId !== null && reportId !== void 0 ? reportId : "",
    }, { skip: !reportId });
    const { status, isRepro } = convertFinalCheckLabel((_a = summary === null || summary === void 0 ? void 0 : summary.checks_report.report.scans[selectedCheck]) === null || _a === void 0 ? void 0 : _a.checks);
    const shouldShowReproTab = isRepro && status === "fail" && riskCategory === "tampering";
    let linkTarget = REPORT_PAGES_ROUTES.ISSUES_ROUTE;
    if (shouldShowReproTab) {
        linkTarget = REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE;
    }
    const handleRiskCountClick = useCallback(() => {
        if (shouldShowReproTab) {
            // handles special case when final risk is tampering caused by repro build fail
            dispatch(scrollTo({
                id: reproID,
                offset: headerHeight * 2,
            }));
        }
        else if (riskCategory) {
            if (violations.length > 0) {
                dispatch(filterByLink({ issue: { operation: "is_any", values: violations } }));
            }
            else {
                dispatch(filterByLink({
                    assessment_category: { operation: "is", values: [riskCategory] },
                }));
            }
        }
    }, [dispatch, riskCategory, violations, shouldShowReproTab]);
    if (!summary) {
        return {
            linkTarget: "",
            handleRiskCountClick: () => null,
        };
    }
    return {
        linkTarget,
        handleRiskCountClick,
    };
};
export default useRiskAssessmentClick;
//# sourceMappingURL=useRiskAssessmentClick.js.map